import React, { Component } from "react";
import { NotificationManager } from "react-notifications";
import { 
    Modal, ModalHeader, ModalBody,
    Row, Col,
    Input, Label, Button, ButtonGroup
 } from "reactstrap";

import TYItem from "../../TYItem";
import Registry from "../../../Utils/Registry";


export default class RecVehicleModal extends Component{
    constructor(props){
        super(props);

        this.state = {
            addingMode: "fleet",
            vehicleId: null,
            model: "",
            color: "",
            plate: "",
            gas: "",
            gasList: [],
            fleet: [],
            addedVehicles: []
        };

        this.api = Registry.registered("api");
    }

    componentDidMount(){
        this.getGasList();
        this.getFleet();
    }

    componentDidUpdate(prevProps){
        if(prevProps.shown !== this.props.shown && this.props.shown){
            if(this.props.updateData !== null){
                this.setState({
                    vehicleId: this.props.updateData.id,
                    model: this.props.updateData.description,
                    color: this.props.updateData.color,
                    plate: this.props.updateData.plate,
                    gas: this.props.updateData.gas_id
                });
            }
            else{
                this.setState({
                    vehicleId: null,
                    model: "",
                    color: "",
                    plate: "",
                    gas: ""
                });
            }
        }
    }

    getGasList = () => {
        this.api.get("/gas?available_to=B2B")
            .then(r => {
                this.setState({gasList: r.gas});
            })
    };

    getFleet = () => {
        this.api.get("/fleet?type=business")
            .then(r => { this.setState({fleet: r.fleet})});
    };

    inputChanged = (e, input_key) => {
        this.setState({
            [input_key]: (typeof e === "string" ? e : e.target.value)
        });
    }

    addVehicle = data => {
        this.setState({loading: true});
        return this.api.post("/recurrent/" + this.props.recId + "/vehicle", data)
            .then(_ => {
                this.setState({loading: false});
                NotificationManager.success("Véhicule ajouté");
            })
            .catch(_ => {
                this.setState({loading: false});
                let errMsg = "Impossible d'ajouter le véhicule";
                NotificationManager.error(errMsg);
            });
    }

    updateVehicle = data => {
        this.setState({loading: true});
        return this.api.put("/recurrent/vehicle/" + this.state.vehicleId, data)
            .then(_ => {
                this.setState({loading: false});
                NotificationManager.success("Véhicule modifié");
            })
            .catch(_ => {
                this.setState({loading: false});
                let errMsg = "Impossible de modifier le véhicule";
                NotificationManager.error(errMsg);
            });
    };

    addCustomVehicle = () => {
        let data = {
            description: this.state.model,
            plate: this.state.plate,
            color: this.state.color,
            gas_id: this.state.gas,
            category: this.state.fleet_category
        };
        if(this.state.vehicleId)
            this.updateVehicle(data).then(this.props.onVehicleAdded);
        else
            this.addVehicle(data).then(this.props.onVehicleAdded);
    }

    addFleetVehicle = vehicle => {
        this.addVehicle(vehicle);
        this.setState({addedVehicles: [...this.state.addedVehicles, vehicle.plate]});
    }

    otherActivityChanged = category => {
        this.setState({fleet_category: category});
    }

    onActivitySelected = category => {
        this.setState({fleet_category: category});
    }

    _toggle = () => {
        this.props.onToggle(this.state.addedVehicles.length > 0);
    }

    render(){
        const {
            shown,
            updateData,
            alreadyAdded,
            ...props
        } = this.props;

        let plateOnRec = [...alreadyAdded, ...this.state.addedVehicles];

        return <Modal isOpen={shown} toggle={this._toggle}>
            <ModalHeader toggle={this._toggle}>{updateData !== null ? "Modifier" : 'Ajouter'} un v&eacute;hicule</ModalHeader>
            <ModalBody>
                {
                    updateData === null ?
                        <Row>
                            <Col xs="12" className="center marg-b-20">
                                <ButtonGroup>
                                    <Button size="sm" color="primary" onClick={() => {this.setState({addingMode: "fleet"})}} outline active={this.state.addingMode === "fleet"}>Flotte</Button>
                                    <Button size="sm" color="primary" onClick={() => {this.setState({addingMode: "other"})}} outline active={this.state.addingMode === "other"}>Autre</Button>
                                </ButtonGroup>
                            </Col>
                        </Row>
                        : null
                }

                {
                    updateData !== null || this.state.addingMode === "other" ?
                        <span>
                            <Row className="marg-b-10">
                                <Col xs="12" sm="6" className="marg-xs-b-10">
                                    <Label for="car_model" className="bold">
                                        Modele
                                    </Label>
                                    <Input value={this.state.model} placeholder="Ex: Citroen C3" onChange={e => this.inputChanged(e, "model")} />
                                </Col>
                                <Col xs="12" sm="6">
                                    <Label for="color_select" className="bold">
                                        Couleur
                                    </Label>
                                    <Input  value={this.state.color} type="select" name="select_color" onChange={e => this.inputChanged(e, "color")}>
                                        <option value="">S&eacute;l&eacute;ctionner une couleur</option>
                                        <option value="Blanc">Blanc</option>
                                        <option value="Noir">Noir</option>
                                        <option value="Gris">Gris</option>
                                        <option value="Jaune">Jaune</option>
                                        <option value="Rouge">Rouge</option>
                                        <option value="Bleu">Bleu</option>
                                        <option value="Vert">Vert</option>
                                        <option value="Orange">Orange</option>
                                        <option value="Violet">Violet</option>
                                    </Input>
                                </Col>
                            </Row>
                            <Row className="marg-b-10">
                                <Col xs="12" sm="6" className="marg-xs-b-10">
                                    <Label for="car_plate" className="bold">
                                        Plaque d'immatriculation
                                    </Label>
                                    <Input value={this.state.plate} placeholder="TY-XXX-12" onChange={e => this.inputChanged(e, "plate")}/>
                                </Col>
                                <Col xs="12" sm="6">
                                    <Label for="gas_select" className="bold">Carburant</Label>
                                    <Input type="select" value={this.state.gas} name="select_gas" onChange={e => this.inputChanged(e, "gas")}>
                                        <option value="">S&eacute;l&eacute;ctionner un carburant</option>
                                        {
                                            this.state.gasList.map((gas, i) => {
                                                return <option key={"gas-" + i} value={gas.id}>{ gas.name }</option>;
                                            })
                                        }
                                    </Input>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs="12" className="center marg-t-20">
                                    <Button className="text-uppercase" color="primary" onClick={this.addCustomVehicle}>
                                        { this.state.loading ? <i className="icon icon-loading animated spin infinite f-18"> </i> : null }
                                        { !this.state.loading && updateData === null ? "Ajouter le véhicule" : null }
                                        { !this.state.loading && updateData !== null ? "Modifier le véhicule" : null }
                                    </Button>
                                </Col>
                            </Row>
                        </span>
                        : null
                }

                {
                    updateData === null && this.state.addingMode === "fleet" ? 
                        this.state.fleet.map((f, i) => {
                            let alreadyInRec = plateOnRec.indexOf(f.plate) !== -1;

                            return <TYItem flagColorCode={f.gas_color} key={`fleet-vehicle-${i}`}>
                                <div className="d-flex marg-t-10 marg-b-10">
                                    <div style={{flex: 2}}>
                                        {f.description} {f.color}<br />
                                        {f.gas_name} - {f.plate}
                                    </div>
                                    <div className="d-flex flex-column align-self-center animated flash">
                                        { 
                                            alreadyInRec ? 
                                                <div className={`center f-10 orange`}>Deja present</div>
                                                :
                                                <button className={`btn btn-outline-success btn-xs`} onClick={() => { this.addFleetVehicle(f); }}>Ajouter</button>
                                        }
                                    </div>
                                </div>
                            </TYItem>;
                        })
                        :
                        null
                }

                {
                    updateData === null && this.state.addingMode === "fleet" && !this.state.fleet.length ? 
                        <div className="center pad-20 gray_dark">
                            Aucun v&eacute;hicule dans la flotte ...
                        </div>
                        :
                        null
                }
            </ModalBody>
        </Modal>
    }
}

RecVehicleModal.defaultProps = {
    onVehicleAdded: () => {},
    shown: false,
    updateData: null,
    alreadyAdded: [],
    recId: null,
    onToggle: _ => {}
};


// WEBPACK FOOTER //
// ./src/components/Operations/Recurrent/vehicleModal.js